import { Navigate, RouteObject } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { RoutePaths } from '@utils/route.utils.ts';

const SalesComponent = lazy(() => import('./sales.tsx'));
const ServiceReservationsComponent = lazy(
  () => import('../service-reservations/service-reservations.tsx')
);
const OrdersComponent = lazy(() => import('../orders/orders.tsx'));

export const salesRoutes: RouteObject[] = [
  {
    path: '',
    element: (
      <Suspense>
        <SalesComponent />
      </Suspense>
    ),
    children: [
      {
        index: true,
        element: (
          <Navigate to={RoutePaths.Core.Sales.Orders.absolutePath} replace />
        )
      },
      {
        path: RoutePaths.Core.Sales.Orders.path,
        element: (
          <Suspense>
            <OrdersComponent />
          </Suspense>
        )
      },
      {
        path: RoutePaths.Core.Sales.ServiceReservation.path,
        element: (
          <Suspense>
            <ServiceReservationsComponent />
          </Suspense>
        )
      }
    ]
  }
];
